import React, { useMemo } from 'react';
// adjust the path if this file isn't in src/components/pages:
import CrossfadeCarousel from './CrossfadeCarousel';

export default function KitchenCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 1.jpg`, alt: 'Kitchen 1' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 2.jpg`, alt: 'Kitchen 2' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 3.jpg`, alt: 'Kitchen 3' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 5.jpg`, alt: 'Kitchen 5' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 6.jpg`, alt: 'Kitchen 6' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 7.jpg`, alt: 'Kitchen 7' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 8.jpg`, alt: 'Kitchen 8' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
      aspectRatio="3/2"
      delay={5000}
      // className="halftone-bg" // optional: add a page-specific bg if you want
    />
  );
}
